import React from 'react';
import { useParams } from 'react-router-dom';
import UserDashboard from '../user/UserDashboard';

const GhostDashboard = () => {
  const { userId } = useParams();
  return <UserDashboard ghostUserId={userId} />;
};

export default GhostDashboard;
